import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import { compose } from 'react-recompose';

import { loadMoreAMConnectionsProp, SimpleLoadingComponent } from '../../utils/apollo';

import AMConnectionsView from './connections-view';
import { STUDENT_CONNECTION_FRAGMENT, LIMIT } from './constants';
import { queryErrorsToWarnings } from '../../components/GraphQLError';

const query = gql`
  query AMPlusRecentConnections($page: Int, $limit: Int) {
    viewer {
      id
      enabledFeatures
      studentConnections: amStudentConnectionsSinceLastExport(page: $page, limit: $limit) {
        pagination {
          page
          totalCount
          hasNextPage
        }
        results {
          ...AMStudentResults
        }
      }
    }
  }
  ${STUDENT_CONNECTION_FRAGMENT}
`;

const graphqlData = graphql(query, {
  options: (props) => ({
    errorPolicy: 'all',
    fetchPolicy: 'network-only',
    variables: {
      page: 1,
      limit: LIMIT,
    },
  }),
  props: compose(
    queryErrorsToWarnings(['studentConnections']),
    loadMoreAMConnectionsProp(query),
  ),
});

export default SimpleLoadingComponent(graphqlData)(AMConnectionsView);
